import { SubSurveysManagerReadModel } from "@Evaluation/CriteriaSurveys/Domain/readmodels";

export class SubSurveysManagerDialogViewModel
{
    opened: boolean = false;

    rm: SubSurveysManagerReadModel = null;
    masterSurveyId: number = null;
    masterSurveyName: string = null;

    show(masterSurveyId: number, masterSurveyName: string)
    {
        this.masterSurveyId = masterSurveyId;
        this.masterSurveyName = masterSurveyName;

        this.opened = true;
    }

    close()
    {
        this.opened = false;
        this.rm = null;
    }

    setData(rm: SubSurveysManagerReadModel)
    {
        this.rm = rm;
    }

    excludeSubSurvey(surveyId: number)
    {
        const s = this.rm.Entries.find(a => a.Id === surveyId);
        s.IsIncluded = false;
    }

    includeSubSurvey(surveyId: number, voteStrength: number)
    {
        const s = this.rm.Entries.find(a => a.Id === surveyId);
        s.VoteStrength = voteStrength;
        s.IsIncluded = true;
    }

    changeSubSurveyVoteStrength(surveyId: number, voteStrength: number)
    {
        const s = this.rm.Entries.find(a => a.Id === surveyId);
        s.VoteStrength = voteStrength;
    }
}